import {
  SELECT_REPORT,
  CLEAR_SELECTED_REPORTS
} from '../actions/selectedReportsActions'

const initialState = {
  data: []
}

const selectedReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_REPORT: {
      return Object.assign(
        {},
        state,
        {
          data: action.data
        }
      )
    }
    case CLEAR_SELECTED_REPORTS:
      return Object.assign(
        {},
        state,
        initialState
      )
    default:
      return state
  }
}

export default selectedReportsReducer